import Cookies from 'js-cookie'
import React, { createContext, useState, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { api, createSession, getUserData } from '../services/api.js'
import { StorageCookies } from '../services/storage_cookies.js'

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null)
	const [loading, setLoading] = useState(true)
	const navigate = useNavigate()

	useEffect(() => {
		;(async () => {
			setLoading(true)
			const recoveredUser = Cookies.get('user')
			const recoveredToken = Cookies.get('access_token')
			const recovered_refreshToken = Cookies.get('refresh_token')
			if (recoveredUser && recoveredToken && recovered_refreshToken) {
				setUser(JSON.parse(recoveredUser))
				api.defaults.headers.Authorization = `Bearer ${JSON.parse(recoveredToken)}`
			}
			setLoading(false)
		})()
	}, [])

	const login = async ({ email, password }) => {
		const error_field = document.querySelector('.error-message')
		error_field.innerHTML = ''
		try {
			setLoading(true)
			document.querySelector('.error-message').classList.add('disabled')
			const response = await createSession(email, password)
			const token = response.data.access_token
			const r_token = response.data.refresh_token
			api.defaults.headers.Authorization = `Bearer ${token}`
			const userResponse = await getUserData()
			const loggedUser = userResponse.data
			setUser(loggedUser)
			StorageCookies({ access_token: token, refresh_token: r_token, user: loggedUser })
			navigate('/home')
		} catch (err) {
			console.log(err)
			if (err.response && err.response.data.detail === 'Incorrect username or password') {
				error_field.innerHTML = 'Email ou senha incorretos.'
			} else {
				error_field.innerHTML = 'Erro ao fazer login.'
			}
			error_field.classList.remove('disabled')
		} finally {
			setLoading(false)
		}
	}

	const logout = () => {
		const c_projects = Cookies.get('projects')
		if (c_projects) {
			const projects = JSON.parse(c_projects)
			projects.map((project) => {
				const id = project.id.toString()
				const test = Cookies.get(id)
				if (test) {
					Cookies.remove(id)
				}
			})
		}
		Cookies.remove('user')
		Cookies.remove('access_token')
		Cookies.remove('refresh_token')
		Cookies.remove('projects')

		api.defaults.headers.Authorization = null
		setUser(null)
		window.location.href = '/login'
	}

	return (
		<AuthContext.Provider value={{ authenticated: !!user, user, loading, login, logout }}>
			{children}
		</AuthContext.Provider>
	)
}
